import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementBlock as _createElementBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { "data-qa": "payment-section" }
const _hoisted_2 = {
  ref: "paymentElementRef",
  class: "_mb-6",
  "data-qa": "stripe-payment-frame"
}
const _hoisted_3 = { class: "gfu-box-actions" }
const _hoisted_4 = { class: "gfu-box-actions__item" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "gfu-box-actions__item" }
const _hoisted_7 = { "data-qa": "create-order-btn:Price" }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "gfu-box-actions" }
const _hoisted_10 = { class: "gfu-box-actions__item _ml-a _pt-0" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_notificator = _resolveComponent("base-notificator")
  const _component_project_benefits_and_risks = _resolveComponent("project-benefits-and-risks")
  const _component_guest_checkout_fieldset = _resolveComponent("guest-checkout-fieldset")
  const _component_terms_of_service_checkbox_field = _resolveComponent("terms-of-service-checkbox-field")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_button = _resolveComponent("base-button")
  const _component_installments_info_box = _resolveComponent("installments-info-box")
  const _component_progress_overlay = _resolveComponent("progress-overlay")
  const _component_create_order_without_payment = _resolveComponent("create-order-without-payment")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($options.notification)
      ? (_openBlock(), _createBlock(_component_base_notificator, {
          key: 0,
          "can-close": false,
          class: "_my-2",
          message: $options.notification.message,
          type: $options.notification.type
        }, null, 8 /* PROPS */, ["message", "type"]))
      : _createCommentVNode("v-if", true),
    ($options.isOrderPayable || $props.isInBackupPaymentMode)
      ? (_openBlock(), _createElementBlock("form", {
          key: 1,
          class: "payment-form _mt-2",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers((...args) => ($options.onSubmit && $options.onSubmit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_2, null, 512 /* NEED_PATCH */),
          _renderSlot(_ctx.$slots, "content", _normalizeProps(_guardReactiveProps({ handleSubmitAction: $options.handleSubmitAction, isProcessing: $setup.isProcessing, onGoBack: $options.onGoBack})), () => [
            ($props.isProjectBenefitsAndRisksVisible)
              ? (_openBlock(), _createBlock(_component_project_benefits_and_risks, {
                  key: 0,
                  class: "_mb-6",
                  "is-stretch-pay-visible": false
                }))
              : _createCommentVNode("v-if", true),
            ($options.areGuestFieldsVisible)
              ? (_openBlock(), _createBlock(_component_guest_checkout_fieldset, {
                  key: 1,
                  "model-value": $data.model.unauthenticatedUser
                }, null, 8 /* PROPS */, ["model-value"]))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_terms_of_service_checkbox_field, {
              modelValue: $data.model.termsAccepted,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.model.termsAccepted) = $event)),
              class: "_mt-6",
              name: "model.termsAccepted"
            }, null, 8 /* PROPS */, ["modelValue"]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("a", {
                  href: $options.projectUrl,
                  class: "_gfu-link _gfu-link--accent _tc--accent _flex _ai-c",
                  onClick: _cache[1] || (_cache[1] = (...args) => ($options.onGoBack && $options.onGoBack(...args)))
                }, [
                  _createVNode(_component_base_icon, {
                    name: "chevron-left _mr-1",
                    "data-qa": "create-order-btn:Back"
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.Resources.Common.GoBackButton), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_5)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_base_button, {
                  type: "submit",
                  theme: "accent",
                  shape: "soft",
                  display: "block",
                  enabled: !$setup.isProcessing,
                  "data-qa": "create-order-btn:Submit"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($options.submitButtonLabel) + " ", 1 /* TEXT */),
                    _createElementVNode("span", _hoisted_7, _toDisplayString($options.amount), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["enabled"]),
                ($options.installmentsSelectedAndPhaseValid)
                  ? (_openBlock(), _createBlock(_component_installments_info_box, {
                      key: 0,
                      amount: _ctx.orderAmountWithSymbol
                    }, null, 8 /* PROPS */, ["amount"]))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" we don't support installments or deposits for Stripe payments ")
              ])
            ])
          ])
        ], 32 /* NEED_HYDRATION */))
      : ($options.isAmendOrCreateOrderInSpecificPhase)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_terms_of_service_checkbox_field, {
              modelValue: $data.model.termsAccepted,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.model.termsAccepted) = $event)),
              name: "model.termsAccepted"
            }, null, 8 /* PROPS */, ["modelValue"]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_base_button, {
                  theme: "accent",
                  class: "gfu-btn--block",
                  onClick: $options.onSubmit,
                  "data-qa": "create-order-btn:Submit"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($options.nonPayableButtonLabel), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"])
              ]),
              _createVNode(_component_progress_overlay, { visible: $setup.isProcessing }, null, 8 /* PROPS */, ["visible"])
            ])
          ]))
        : (_openBlock(), _createBlock(_component_create_order_without_payment, _normalizeProps(_mergeProps({ key: 3 }, {..._ctx.$props})), null, 16 /* FULL_PROPS */)),
    _createVNode(_component_progress_overlay, { visible: $setup.isProcessing }, null, 8 /* PROPS */, ["visible"])
  ]))
}